module.exports = __webpack_public_path__ + "img/hvac-icon.8b7afa81.svg";